import React from 'react';
import { NotRolesWrapper } from './styled';

export const NotRoles = () => {
  const NOT_ROLES = <NotRolesWrapper>Usuario no tiene configurado roles.</NotRolesWrapper>;

  return NOT_ROLES;
};
